import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { UploadMetadata } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetMatterUploadHistory = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UploadMetadata[]>(
    [QueryEntity.UploadHistory, matterId],
    () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/upload-history`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
